(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sol-hero-v3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sol-v3-hero]').forEach((root) => {
    if (root.dataset.drawerReady === 'true') return;
    root.dataset.drawerReady = 'true';

    const openButton = root.querySelector('.sol-hero-v3__menu-button');
    const closeButton = root.querySelector('.sol-hero-v3__close');
    const drawer = root.querySelector('.sol-hero-v3__drawer');
    const scrim = root.querySelector('.sol-hero-v3__scrim');

    if (!openButton || !closeButton || !drawer || !scrim) return;

    const setOpen = (isOpen) => {
      drawer.setAttribute('aria-hidden', String(!isOpen));
      openButton.setAttribute('aria-expanded', String(isOpen));
      scrim.classList.toggle('is-open', isOpen);
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen) closeButton.focus();
      else openButton.focus();
    };

    openButton.addEventListener('click', () => setOpen(true));
    closeButton.addEventListener('click', () => setOpen(false));
    scrim.addEventListener('click', () => setOpen(false));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') setOpen(false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sol-sticky-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.getElementById('sol-sticky-bar');
  
  if (stickyBar) {
    const scrollThreshold = parseInt(stickyBar.dataset.scrollThreshold) || 300;
    const enabledOnMobile = stickyBar.dataset.enabledOnMobile === 'true';
    
    // Don't initialize on mobile if not enabled
    if (!enabledOnMobile && window.innerWidth < 750) {
      return;
    }
    
    // Function to check scroll position and toggle sticky bar
    function checkScroll() {
      if (window.scrollY > scrollThreshold) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    }
    
    // Add scroll event listener with throttling for performance
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial check
    checkScroll();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutello-footer-accordion"] && !Shopify.designMode) return;
  try {
    
class FooterAccordion {
  constructor() {
    this.init();
  }

  init() {
    const buttons = document.querySelectorAll('.footer-accordion__button');
    const mediaQuery = window.matchMedia('(min-width: 990px)');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        if (!mediaQuery.matches) {
          this.toggleSection(button);
        }
      });
    });
  }

  toggleSection(button) {
    const content = document.getElementById(button.getAttribute('aria-controls'));
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', !isExpanded);
    
    if (isExpanded) {
      content.style.display = 'none';
    } else {
      content.style.display = 'block';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FooterAccordion();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutello-header-navigation"]) return;
  try {
    
class HeaderNavigation {
  constructor() {
    this.init();
  }

  init() {
    this.mobileMenuToggle = document.querySelector('.header__mobile-menu-toggle');
    this.searchToggle = document.querySelector('.header__search-toggle');
    
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.addEventListener('click', () => this.toggleMobileMenu());
    }
    
    if (this.searchToggle) {
      this.searchToggle.addEventListener('click', () => this.toggleSearch());
    }
    
    this.setupMegaMenus();
  }

  setupMegaMenus() {
    const megaMenuItems = document.querySelectorAll('.header__menu-item--has-dropdown');
    
    megaMenuItems.forEach(item => {
      const link = item.querySelector('.header__menu-link');
      const submenu = item.querySelector('.header__submenu');
      
      if (window.innerWidth >= 990) {
        item.addEventListener('mouseenter', () => {
          submenu.style.display = 'block';
        });
        
        item.addEventListener('mouseleave', () => {
          submenu.style.display = 'none';
        });
      }
    });
  }

  toggleMobileMenu() {
    const mobileMenu = document.querySelector('.mobile-menu');
    mobileMenu.classList.toggle('is-active');
  }

  toggleSearch() {
    // Implement search functionality
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderNavigation();
});

  } catch(e) { console.error(e); }
})();
})();
